<template>
  <el-input
    type="textarea"
    :model-value="props.modelValue"
    :autosize="autosize"
    :disabled="props.disabled"
    :maxlength="props.maxlength"
    :show-word-limit="Boolean(props.maxlength)"
    class="[&_textarea]:resize-none"
    :class="props.showWordLimit ? 'el-textarea--show-word-limit' : ''"
    @update:model-value="(payload) => emit('update:modelValue', payload)"
  />
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: Number,
    default: undefined,
  },
  autosize: {
    type: Object,
    default: () => ({
      minRows: 5,
      maxRows: 32,
    }),
  },
});

const emit = defineEmits(['update:modelValue']);
</script>
